<template>
  <vs-popup fullscreen title="Code Step Edit" :active.sync="popupActive" v-if="popupActive">
    <MonacoEditor key="code"
                  suffix="freeHtml"
                  ref="monacoCodeEditor"
                  :text_value="htmlValue"
                  language="html"
                  theme="vs-dark" />
    <vs-button color="dark"
               @click="onSaveFreeHtml"
               style="float:left"
               type="line"
               icon-pack="feather"
               icon="icon-save"
               icon-after />
  </vs-popup>
</template>

<script>
import MonacoEditor from '../MonacoEditor.vue'

export default {
  name: 'FreeHtmlEditorPopup',

  components: {
    MonacoEditor
  },

  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    htmlValue: {
      type: String,
      default: ''
    },

  },

  data() {
    return {

    }
  },

  computed: {
    popupActive: {
      get() {
        return this.isActive
      },
      set(value) {
        this.$emit('update:isActive', value)
      }
    },
  },

  methods: {

    onCopyCode() {
      this.$emit('copy-code', this.$refs.monacoCodeEditor.getValue())
    },

    onSaveFreeHtml() {
      this.$emit('save-free-html', this.$refs.monacoCodeEditor.getValue())
    }
  }
}
</script>
